import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash-es';
import {
  TMV_CONDITION_ERROR_TRACKING,
  PARTNER_OFFER_NO_OFFER_TMV_TRACKING_CREATIVE_ID,
} from 'site-modules/shared/constants/appraisal/appraisal';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { AppraisalNoOfferLinks } from 'site-modules/shared/components/appraisal/appraisal-no-offer-links/appraisal-no-offer-links';

import './appraisal-report-error-message.scss';

export function AppraisalReportErrorMessageNoTmvFound({ getVehicleData, toggleAppraiserDrawer }) {
  return (
    <div data-tracking-parent={PARTNER_OFFER_NO_OFFER_TMV_TRACKING_CREATIVE_ID}>
      <div className="appraisal-report-error-message bg-white text-gray-darker text-center pt-2_5 pb-1_5 px-2 mb-2">
        <span className="icon-edmunds-car text-primary size-30" aria-hidden />
        <h2 className="size-24">
          We&apos;re sorry. We are unable to generate an appraisal report for your car at this time.
        </h2>
        <p>Your vehicle is either too new, too old or too rare.</p>
      </div>
      <AppraisalNoOfferLinks getVehicleData={getVehicleData} toggleAppraiserDrawer={toggleAppraiserDrawer} />
    </div>
  );
}

AppraisalReportErrorMessageNoTmvFound.propTypes = {
  getVehicleData: PropTypes.func.isRequired,
  toggleAppraiserDrawer: PropTypes.func.isRequired,
};

export class AppraisalReportErrorMessage extends Component {
  static propTypes = {
    getVehicleData: PropTypes.func.isRequired,
    isExtendedReport: PropTypes.bool,
    validOffer: PropTypes.bool,
    isOfferLoading: PropTypes.bool,
    vin: PropTypes.string,
    toggleAppraiserDrawer: PropTypes.func,
  };

  static defaultProps = {
    isExtendedReport: false,
    validOffer: false,
    isOfferLoading: false,
    vin: '',
    toggleAppraiserDrawer: null,
  };

  componentDidUpdate(prevProps) {
    const { vin, isExtendedReport, validOffer, isOfferLoading } = this.props;
    const isOfferLoaded = !isOfferLoading && prevProps.isOfferLoading;
    if (isExtendedReport && !validOffer && isOfferLoaded) {
      EventToolbox.fireTrackAction(TMV_CONDITION_ERROR_TRACKING);
    }
    if (vin && !validOffer && isOfferLoaded) {
      EventToolbox.fireTrackAction(
        merge({}, TMV_CONDITION_ERROR_TRACKING, {
          event_data: {
            subaction_name: TrackingConstant.SUBACTION_VIN_ERROR,
            value: `${this.props.vin}_${TrackingConstant.SUBACTION_EPO_OFFER}_TMV_REPORT_ERROR`,
          },
        })
      );
    }
  }

  render() {
    const { getVehicleData, isExtendedReport, toggleAppraiserDrawer } = this.props;

    if (isExtendedReport) {
      return (
        <AppraisalReportErrorMessageNoTmvFound
          getVehicleData={getVehicleData}
          toggleAppraiserDrawer={toggleAppraiserDrawer}
        />
      );
    }

    return (
      <div data-tracking-parent={PARTNER_OFFER_NO_OFFER_TMV_TRACKING_CREATIVE_ID}>
        <div className="appraisal-report-error-message bg-white text-gray-darker text-center pt-2_5 pb-1_5 px-2 mb-2">
          <span className="icon-edmunds-car text-primary size-30" aria-hidden />
          <h2 className="size-24">
            We&apos;re sorry. We are unable to generate an appraisal report for your car at this time.
          </h2>
        </div>
        <AppraisalNoOfferLinks getVehicleData={getVehicleData} toggleAppraiserDrawer={toggleAppraiserDrawer} />
      </div>
    );
  }
}
